(function () {
  angular.module('binky.core.download-utils', [
    'binky.core.feature',
    'binky.core.lodash',
    'binky.core.src2-migration',
  ]);
})();
